export default __webpack_public_path__ + "static/media/MENSTRUAL-IRREGULARITY.106ee03b.png";